<template>
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <path
        d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
        fill="none"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-width="32"
      />
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M352 176L217.6 336 160 272"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Close",
};
</script>

<style scoped lang="scss">
.icon {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/CheckCircle.vue